<template>
  <div>
    <div class="col container" v-show="step == 0">
      <div class="step-fm mt-4">
        <UploadStepVue :prop_active="0" class="step-bg"></UploadStepVue>
        <el-upload
          class="upload-demo"
          ref="upload2"
          :auto-upload="false"
          drag
          :limit="1"
          :show-file-list="false"
          :on-change="videoSaveToUrl"
          :action="uploadUrl"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
             {{ $t('Social.VideoUpload.msg') }}<em> {{ $t('Social.VideoUpload.Clickupload') }}</em>
          </div>
          <div class="el-upload__tip" slot="tip" style="text-align: center">
            <ul>
              <li v-show="fileName != ''">
                 {{ $t('Social.VideoUpload.Selected') }}<span style="font-size: 24px; color: #26ad5e">{{
                  fileName
                }}</span>
              </li>
              <li> {{ $t('Social.VideoUpload.Only') }}</li>
              <li> {{ $t('Social.VideoUpload.uploads') }}</li>
              <li> {{ $t('Social.VideoUpload.recommended') }}</li>
              <li> {{ $t('Social.VideoUpload.website') }}</li>
            </ul>
          </div>
        </el-upload>
      </div>
      <div class="video-uploader"></div>
      <div class="step-fm">
        <el-button type="primary" @click="ck1" class="float-right"
          > {{ $t('Social.VideoUpload.next') }}</el-button
        >
      </div>
    </div>
    <div class="container uploading" v-show="step == 1">
      <div class="step-fm mt-4">
        <div id="app2">
          <UploadStepVue
            ref="UploadStepVue2"
            :prop_active="1"
            class="step-bg"
          ></UploadStepVue>
          <div class="col-12">
            <div class="card card-primary">
              <div class="card-body">
                <div class="row mb-4">
                  <div class="col-12">
                    <label for="upload-label"> {{ $t('Social.VideoUpload.Uploadprogress') }}</label>
                    <el-progress
                      :text-inside="true"
                      :stroke-width="24"
                      :percentage="progress"
                      status="success"
                    ></el-progress>
                  </div>
                </div>
                <div class="row">
                  <div class="section-group col-md-12 col-lg-4 pr-lg-4">
                    <label for="video-image"
                      > {{ $t('Social.VideoUpload.thumbnail') }}</label
                    >
                    <div class="video-thumbnail w-100" v-if="videoImg == ''">
                      <div class="video-responsive mb-2">
                        <div class="video-sizer"></div>
                        <div class="video-content">
                          <div class="layout h-100 align-center ma-0">
                            <div class="layout-flex">
                              <div class="text-center o-60">
                                <i class="fas fa-film fa-2x"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="video-thumbnail w-100" v-else>
                      <div class="video-responsive mb-2">
                        <div class="video-sizer"></div>
                        <div class="video-content">
                          <div class="layout h-100 align-center ma-0">
                            <div class="layout-flex">
                              <div class="text-center o-60">
                                <img :src="videoImg" class="pr-vi-img" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <el-upload
                      class="upload-demo"
                      action=""
                      :limit="1"
                      :auto-upload="false"
                      :on-change="changeUpload"
                      :show-file-list="false"
                      ref="fmtUpload"
                    >
                      <button
                        type="button"
                        class="btn btn-block btn-default btn-sm mb-3"
                      >
                        <i class="nav-icon fas fa-image mr-1"></i>  {{ $t('Social.VideoUpload.custom') }}
                      </button>
                    </el-upload>
                    <ImgCropperVue
                      class="ImgCropperVue"
                      ref="cro"
                      @cropperConfirm="cropperConfirm"
                      @cropperCancel="cropperCancel"
                      :props_autoCropWidth="1280"
                      :props_autoCropHeight="720"
                      :props_full="false"
                      :props_original="true"
                      :props_centerBox="true"
                      :props_high="true"
                      :props_fixed="true"
                      :props_info="true"
                      :props_canMove="true"
                      :props_fixedNumber="[1.7777, 1]"
                    >
                    </ImgCropperVue>
                    <div class="pr-vi-img-fm" v-show="fmtImg != ''">
                      <div class="pr-vi-img-txt"> {{ $t('Social.VideoUpload.image_yourself') }}</div>
                      <img :src="fmtImg" class="pr-vi-img" />
                    </div>
                    <dl class="row">
                      <dt class="col-4"> {{ $t('Social.VideoUpload.Filename') }}</dt>
                      <dd class="col-8">{{ fileName }}</dd>
                      <dt class="col-4"> {{ $t('Social.VideoUpload.Filesize') }}</dt>
                      <dd class="col-8">{{ fileWidth }}x{{ fileHight }}</dd>
                      <dt class="col-4"> {{ $t('Social.VideoUpload.File_size') }}</dt>
                      <dd class="col-8" v-if="uploadVideo != null">
                        {{ (uploadVideo.size / 1024 / 1024).toFixed(2) }}M
                      </dd>
                      <dt class="col-4"> {{ $t('Social.VideoUpload.uploader') }}</dt>
                      <dd class="col-8">{{ loginUser.displayName }}</dd>
                      <dt class="col-4"> {{ $t('Social.VideoUpload.Uploadtime') }}</dt>
                      <dd class="col-8">{{ videoCreateTime }}</dd>
                    </dl>
                  </div>
                  <div class="section-group col-md-12 col-lg-8">
                    <el-form
                      :model="ruleForm"
                      :rules="rules"
                      ref="ruleForm2"
                      label-width="100px"
                      class="demo-ruleForm"
                      label-position="top"
                    >
                      <el-form-item :label="$t('Social.VideoUpload.Filmtitle')" prop="name">
                        <el-input
                          v-model="ruleForm.name"
                          maxlength="28"
                          show-word-limit
                        ></el-input>
                      </el-form-item>
                      <el-form-item :label="$t('Social.VideoUpload.Filmdescription')" prop="desc">
                        <el-input
                          type="textarea"
                          :rows="4"
                          show-word-limit
                          maxlength="124"
                          v-model="ruleForm.desc"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="$t('Social.VideoUpload.key')"
                        prop="key"
                      >
                        <el-input
                          v-model="ruleForm.key"
                          :placeholder="$t('Social.VideoUpload.eg')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item prop="privacy" :label="$t('Social.VideoUpload.privacy')">
                        <el-select
                          v-model="ruleForm.privacy"
                          :placeholder="$t('Social.VideoUpload.placeholder')"
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-12">
              <el-button type="info" @click="step2s"> {{ $t('Social.VideoUpload.last') }}</el-button>
              <el-button type="primary" @click="step2x" class="float-right"
                > {{ $t('Social.VideoUpload.next') }}</el-button
              >
            </div>
          </div>
        </div>
        <!-- /.id = app2 -->
      </div>
    </div>
    <div class="container uploading" v-show="step == 2">
      <div class="step-fm mt-4">
        <div id="app2">
          <UploadStepVue
            ref="UploadStepVue3"
            :prop_active="2"
            class="step-bg"
          ></UploadStepVue>
          <div class="col-12">
            <div class="card card-primary">
              <div class="card-body">
                <div class="row mb-4">
                  <div class="col-12">
                    <label for="upload-label"> {{ $t('Social.VideoUpload.Uploadprogress') }}</label>
                    <el-progress
                      :text-inside="true"
                      :stroke-width="24"
                      :percentage="progress"
                      status="success"
                    ></el-progress>
                  </div>
                </div>
                <div class="row">
                  <div class="section-group col-md-12 col-lg-4 pr-lg-4">
                    <label for="video-image"
                      > {{ $t('Social.VideoUpload.thumbnail') }}</label
                    >
                    <div class="video-thumbnail w-100">
                      <div class="video-responsive mb-2">
                        <div class="video-sizer"></div>
                        <div class="video-content">
                          <div class="layout h-100 align-center ma-0">
                            <div class="layout-flex">
                              <div class="text-center o-60">
                                <i class="fas fa-film fa-2x"></i>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="pr-vi-img-fm" v-show="fmtImg != ''">
                      <div class="pr-vi-img-txt"> {{ $t('Social.VideoUpload.msg3') }}</div>
                      <img :src="fmtImg" class="pr-vi-img" />
                    </div>
                    <dl class="row">
                      <dt class="col-4"> {{ $t('Social.VideoUpload.Filename') }}</dt>
                      <dd class="col-8">{{ fileName }}</dd>
                      <dt class="col-4"> {{ $t('Social.VideoUpload.Filesize') }}</dt>
                      <dd class="col-8">{{ fileWidth }}x{{ fileHight }}</dd>
                      <dt class="col-4"> {{ $t('Social.VideoUpload.File_size') }}</dt>
                      <dd class="col-8" v-if="uploadVideo != null">
                        {{ (uploadVideo.size / 1024 / 1024).toFixed(2) }}M
                      </dd>
                      <dt class="col-4"> {{ $t('Social.VideoUpload.uploader') }}</dt>
                      <dd class="col-8">{{ loginUser.displayName }}</dd>
                      <dt class="col-4"> {{ $t('Social.VideoUpload.Uploadtime') }}</dt>
                      <dd class="col-8">{{ videoCreateTime }}</dd>
                      <!-- <dt class="col-4">影片連結</dt>
                      <dd class="col-8">{{ showVideoUrl }}</dd> -->
                    </dl>
                  </div>
                  <div class="section-group col-md-12 col-lg-8">
                    <el-form
                      :model="ruleForm"
                      :rules="rules"
                      ref="ruleForm3"
                      label-width="100px"
                      class="demo-ruleForm"
                      label-position="top"
                      :disabled="true"
                    >
                      <el-form-item :label="$t('Social.VideoUpload.Filmtitle')" prop="name">
                        <el-input
                          v-model="ruleForm.name"
                          maxlength="28"
                          show-word-limit
                        ></el-input>
                      </el-form-item>
                      <el-form-item :label="$t('Social.VideoUpload.Filmdescription')" prop="desc">
                        <el-input
                          type="textarea"
                          :rows="4"
                          show-word-limit
                          maxlength="124"
                          v-model="ruleForm.desc"
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        :label="$t('Social.VideoUpload.key')"
                        prop="key"
                      >
                        <el-input
                          v-model="ruleForm.key"
                          :placeholder="$t('Social.VideoUpload.eg')"
                        ></el-input>
                      </el-form-item>
                      <el-form-item prop="privacy" :label="$t('Social.VideoUpload.privacy')">
                        <el-select
                          v-model="ruleForm.privacy"
                          :placeholder="$t('Social.VideoUpload.placeholder')"
                        >
                          <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-12">
              <el-button type="info" @click="step3s"> {{ $t('Social.VideoUpload.last') }}</el-button>
              <el-button type="primary" @click="step3x" class="float-right"
                > {{ $t('Social.VideoUpload.next') }}</el-button
              >
            </div>
          </div>
        </div>
        <!-- /.id = app2 -->
      </div>
    </div>
    <div class="container uploading" v-show="step == 3">
      <div class="step-fm mt-4">
        <div id="app2">
          <UploadStepVue
            ref="UploadStepVue3"
            :prop_active="3"
            class="step-bg"
          ></UploadStepVue>
          <div class="col-12">
            <div class="card card-primary">
              <div class="card-body">
                <div class="row mb-4">
                  <div class="col-12">
                    <label for="upload-label"> {{ $t('Social.VideoUpload.Uploadprogress') }}</label>
                    <el-progress
                      :text-inside="true"
                      :stroke-width="24"
                      :percentage="progress"
                      status="success"
                    ></el-progress>
                  </div>
                </div>
                <div class="video-thumbnail">
                  <video
                    v-if="fmtImg != ''"
                    controls="controls"
                    preload="metadata"
                    playsinline=""
                    class="showVideo"
                    :poster="fmtImg"
                    :src="showVideoUrl"
                  ></video>
                  <video
                    v-else
                    controls="controls"
                    preload="metadata"
                    playsinline=""
                    :poster="videoImg"
                    class="showVideo"
                    :src="showVideoUrl"
                  ></video>
                </div>
                <div class="col-10 pt-4">
                  <dl class="row">
                    <dt class="col-4"> {{ $t('Social.VideoUpload.Filename') }}</dt>
                    <dd class="col-8">{{ fileName }}</dd>
                    <dt class="col-4"> {{ $t('Social.VideoUpload.Filesize') }}</dt>
                    <dd class="col-8">{{ fileWidth }}x{{ fileHight }}</dd>
                    <dt class="col-4"> {{ $t('Social.VideoUpload.File_size') }}</dt>
                    <dd class="col-8" v-if="uploadVideo != null">
                      {{ (uploadVideo.size / 1024 / 1024).toFixed(2) }}M
                    </dd>
                    <dt class="col-4"> {{ $t('Social.VideoUpload.uploader') }}</dt>
                    <dd class="col-8">{{ loginUser.displayName }}</dd>
                    <dt class="col-4"> {{ $t('Social.VideoUpload.Uploadtime') }}</dt>
                    <dd class="col-8">{{ videoCreateTime }}</dd>
                    <dt class="col-4"> {{ $t('Social.VideoUpload.Videolink') }}</dt>
                    <dd class="col-8">
                      <i
                        @click="cp"
                        aria-hidden="true"
                        class="fa fa-clone float-left"
                      ></i>
                      {{ copyVideoUrl }}
                    </dd>
                  </dl>
                </div>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <el-button type="primary" @click="ok" class="float-right"
              > {{ $t('Social.VideoUpload.ok') }}</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <div id="clz" class="modal" data-backdrop="static">
      <div class="modal-dialog feedpost-ensize">
        <div>
          <div class="col">
            <div class="count-main-content">
              <div id="ant">{{ ant }}</div>
              <p class="ant_txt"> {{ $t('Social.VideoUpload.processing') }}</p>
              <div class="counterframe">
                <img src="../../assets/images/video/g0R9.gif" height="100" />
              </div>
            </div>
          </div>
          <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
      </div>
      <!-- /.modal -->
    </div>
    <div id="conf" class="modal" data-backdrop="static">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title"> {{ $t('Social.VideoUpload.Tips') }}</h5>
          </div>
          <div class="modal-body">
             {{ $t('Social.VideoUpload.msg2') }}
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
             {{ $t('Social.VideoUpload.cancel') }}
            </button>
            <button class="btn btn-primary" type="button" @click="saveInfo">
              <span
                v-if="loadingSaveBtn"
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              {{ $t('Social.VideoUpload.confirm') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import base from "../../api/httpApi/base";
import { Message } from "element-ui";
import fileupload from "../../assets/backJs/util2";
import UploadStepVue from "./UploadStep.vue";
import ImgCropperVue from "../common/ImgCropper.vue";
import socialTool from "../../assets/js/socialJs/tool";
export default {
  data() {
    return {
      loadingSaveBtn: false,
      ant: 30,
      timer: null,
      videoCreateTime: "",
      fmtImgId: 0,
      fmtImg: "",
      videoImg: "",
      videoImgId: 0,
      step: 0,
      loadingTxt: "",
      uploadUrl: "",
      uploadVideo: null,
      fileHight: 0,
      fileWidth: 0,
      fileDuration: 0,
      showVideoId: 0,
      showVideoUrl: "",
      copyVideoUrl: "",
      fileName: "",
      img: "",
      progress: 0,
      ruleForm: {
        name: "",
        desc: "",
        key: "",
        privacy: "1",
        isDisable: false,
      },
      rules: {
        name: [
          { required: true, message: "請輸入影片標題", trigger: "blur" },
          {
            min: 1,
            max: 28,
            message: "长度在 1 到 28 个字符",
            trigger: "blur",
          },
        ],
      },
      options: [
        {
          value: "1",
          label: "公開",
        },
        {
          value: "0",
          label: "不公開，只有得知影片連結的人才能觀看",
        },
      ],
    };
  },
  components: {
    UploadStepVue,
    ImgCropperVue,
  },
  mounted() {
    window.onscroll = null;
  },
  created() {
    if (this.loginUser != null) {
      this.uploadUrl = `${base.dev}/TokenAuth/UploadImg/Upload/FormImg?Type=moiveCommunity&id=${this.loginUser.userId}`;
    }
    this.checkIsCert();
  },
  methods: {
    djs() {
      this.timer = setInterval(() => {
        this.ant--;
        if (this.ant <= 0) {
          clearInterval(this.timer);
          this.timer = null;
          this.hideWindow();
        }
      }, 1000);
    },
    hideWindow() {
      $("#clz").modal("hide");
    },
    showWindow() {
      this.ant = 30;
      $("#clz").modal("show");
      this.djs();
    },
    showConfWindow() {
      $("#conf").modal("show");
    },
    hideConfWindow() {
      $("#conf").modal("hide");
    },
    ok() {
      this.$router.push({
        name: "MyDynamicPic",
        params: { showType: 1 },
      });
    },
    cp() {
      this.copyToClipboard(this.copyVideoUrl, true);
    },
    changeUpload(file, fileList) {
      this.$refs.fmtUpload.clearFiles();
      switch (file.raw.type) {
        case "image/jpeg":
          break;
        case "image/png":
          break;
        default:
          this.$message({
            message: "請選擇jpg/png格式",
          });
          return;
      }
      /* const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error(`上傳文件大小不能超過 5MB!`);
        return false;
      } */
      let test = new Image();
      test.src = window.URL.createObjectURL(file.raw);
      let width = 0;
      let height = 0;
      let that = this;
      test.onload = function () {
        width = test.width;
        height = test.height;
        that.$refs.cro.initData(file);
        that.$refs.cro.setDialogVisible(true);
      };
    },
    cropperCancel() {
      this.$refs.fmtUpload.clearFiles();
    },
    cropperConfirm(img) {
      let formData = new FormData();
      formData.append("file", img, "DX.jpg");
      this.$api.albumApi
        .uploadImages(this.uploadUrl, formData)
        .then((res) => {
          if (res.data.success) {
            this.fmtImgId = res.data.result.uploadId;
            this.fmtImg = res.data.result.url;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          console.log(err);
        });
      this.$refs.cro.setDialogVisible(false);
    },
    ck1() {
      if (this.uploadVideo != null) {
        this.step = 1;
        if (this.progress == 0) {
          this.submitUpload();
        }
      } else {
        Message({
          type: "warning",
          message: "請選擇視頻",
        });
      }
    },
    step2s() {
      this.step = 0;
    },
    step2x() {
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          this.step = 2;
          document.documentElement.scrollTop = 0;
        }
      });
    },
    step3s() {
      this.step = 1;
    },
    step3x() {
      //判断视频是否上传完毕
      if (this.showVideoId == 0) {
        Message({
          type: "warning",
          message: "視頻未上傳完畢",
        });
        return;
      }
      this.showConfWindow();
    },
    saveInfo() {
      this.loadingSaveBtn = true;
      let params = {
        sgL_MoiveTempId: this.showVideoId,
        sgL_Content: this.ruleForm.desc,
        sgL_Type: 0,
        sgL_Size: this.uploadVideo.size,
        sgL_length: this.fileDuration,
        width: this.fileWidth,
        height: this.fileHight,
        sgL_Title: this.ruleForm.name,
        sgL_Keyworld: this.ruleForm.key,
        sgL_IsShow: this.ruleForm.privacy,
        sgL_ImageTempId: this.fmtImgId > 0 ? this.fmtImgId : this.videoImgId,
      };
      this.$api.social.CreateSocialData(params).then((res) => {
        this.loadingSaveBtn = false;
        this.hideConfWindow();
        if (res.data.success) {
          this.copyVideoUrl = socialTool.copyLink(res.data.result.id);
          this.step = 3;
          //弹出处理框
          document.documentElement.scrollTop = 0;
          this.showWindow();
        } else {
          this.$message({
            type: "error",
            message: res.data.error.message,
          });
        }
      });
    },
    clearData() {
      this.showVideoId = 0;
      this.fileHight = 0;
      this.fileWidth = 0;
      this.fileDuration = 0;
      this.showVideoUrl = "";
      this.copyVideoUrl = "";
      this.$refs.upload2.clearFiles();
    },
    checkIsCert() {
      //   //判断是否已认证
      //   if (!this.IsNullOrEmpty(this.loginUser) && !this.loginUser.sgL_IsCheck) {
      //     //跳转到认证页面
      //     this.$router.push({
      //       name: "certification",
      //       query: { redirect: this.$route.fullPath },
      //     });
      //     return;
      //   }
      return true;
    },
    videoSaveToUrl(event) {
      if (this.checkIsCert()) {
        if (
          [
            "video/mp4",
            "video/quicktime",
            "video/mpeg",
            "video/3gpp",
            "video/x-flv",
          ].indexOf(event.raw.type) == -1
        ) {
          Message({
            type: "warning",
            message: "請上傳正確的視頻格式",
          });
          this.$refs.upload2.clearFiles();
          return false;
        }
        this.getVideoMsg(event.raw)
          .then((res) => {
            this.fileHight = res.height;
            this.fileWidth = res.width;
            this.fileDuration = res.duration;
          })
          .then(() => {
            //最新需求 增加到90秒
            if (this.fileDuration > 90) {
            // if (this.fileDuration > 60) {
              Message({
                type: "warning",
                message: "視頻時間限制於1.5分鐘(90秒)內",
              });
              this.$refs.upload2.clearFiles();
              this.fileName;
            } else {
              this.uploadVideo = event.raw;
              this.fileName = event.raw.name;
              this.progress = 0;
              this.videoImg = "";
              this.$refs.upload2.clearFiles();
            }
            //console.log(this.fileHight, this.fileWidth, this.fileDuration);
          });
      }
    },
    getVideoMsg(file) {
      return new Promise((resolve) => {
        let videoElement = document.createElement("video");
        videoElement.src = URL.createObjectURL(file);
        videoElement.addEventListener("loadedmetadata", function () {
          resolve({
            duration: videoElement.duration,
            height: videoElement.videoHeight,
            width: videoElement.videoWidth,
          });
        });
      });
    },
    submitUpload() {
      fileupload.uploadFile(
        this.uploadVideo, //视频文件
        this.loginUser.accessToken, //权限token
        this.loginUser.userId,
        (uploadsuccess) => {
          //上传成功的函数
          this.uploadunite(uploadsuccess);
        },
        (successfile) => {
          this.$refs.upload2.clearFiles();
          this.showVideoId = successfile.result.uploadId; //给视频id赋值
          this.showVideoUrl = successfile.result.url;
          this.videoCreateTime = successfile.result.createTime;
          this.progress = 100;
          //this.ck1();
        },
        (process) => {
          //进度回调函数
          this.progress = process.toFixed(0) * 1;
        },
        (failePage) => {
          //分片上傳時如果服務斷掉會進入這裏
          Message({
            type: "error",
            message: failePage,
          });
          this.updateError = "，請檢查網絡！";
          this.$refs.upload2.clearFiles();
        }
      );
    },
    uploadunite(uploadsuccess) {
      this.loadingTxt = "上傳中";
      //合并
      this.$api.VideoApi.uploadfileGather2(uploadsuccess)
        .then((res) => {
          if (res.data.success == false) {
            this.isShowUploadVideo = false;
            Message({
              type: "error",
              message: res.data.error.message,
            });
            this.loadingTxt = "合并視頻失敗," + res.data.error.message;
            this.$refs.upload2.clearFiles();
          } else {
            this.showVideoId = res.data.result.uploadId; //给视频id赋值
            this.showVideoUrl = res.data.result.url;
            this.videoCreateTime = res.data.result.createTime;
            //this.ck1();
          }
        })
        .catch((error) => {
          //請求失敗攔截
          if (this.num < 4) {
            setTimeout(() => {
              this.uploadunite(uploadsuccess);
              this.num++;
            }, 30000);
          }
        });
    },
  },
};
</script>

<style scoped>
.upload-demo >>> .el-upload-dragger {
  width: 100%;
}

#ant {
  width: 150px;
  height: 50px;
  color: #fff;
  text-align: center;
  line-height: 50px;
  margin: 0px auto;
  position: absolute;
}
.ant_txt {
  text-align: center;
  position: absolute;
  color: #fff;
  margin-top: 40px;
}
#counterframe {
  position: absolute;
}
.count-main-content {
  background: #000;
  height: 260px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
}
.showVideo {
  width: 100%;
}
@media (min-width: 1200px) {
  .showVideo {
    height: 600px !important;
  }
}
@media (min-width: 992px) and (max-width: 1199px) {
  .showVideo {
    height: 300px !important;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .showVideo {
    height: 300px !important;
  }
}
@media (min-width: 576px) and (max-width: 767px) {
  .showVideo {
    height: 300px !important;
  }
}
@media (max-width: 575px) {
  .showVideo {
    height: 300px !important;
  }
}
.step-bg {
  padding: 0px 20px;
}
.modal .btn {
  margin-left: initial;
}
#conf .modal-dialog {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/Social/VideoUpload.vue